module.exports = __webpack_public_path__ + "img/oshirifuki_g.813f7944.png";